import React from 'react'
import PropTypes from 'prop-types'
import { Fab, Tooltip } from '@material-ui/core'

function TooltipFab({ Icon, onClick, tooltip, tooltipProps, ...rest }) {
  return (
    <Tooltip title={tooltip} {...tooltipProps}>
      <Fab size='small' color='primary' onClick={onClick} {...rest} >
        <Icon />
      </Fab>
    </Tooltip>
  )
}

TooltipFab.props = {
  Icon: PropTypes.oneOfType([
    PropTypes.func, 
    PropTypes.element,
    PropTypes.elementType
  ]).isRequired,
  onClick: PropTypes.func,
  tooltip: PropTypes.string,
  tooltipProps: PropTypes.object,
}

TooltipFab.defaultProps = {
  tooltip: null,
  tooltipProps: {},
  onClick: () => true
}

export default TooltipFab